import React from "react";
import { PropTypes } from "prop-types";
import { withTranslation } from "react-i18next";
import moment from "moment";
import { useSelector } from "react-redux";

import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineDot from "@material-ui/lab/TimelineDot";
import TimelineContent from "@material-ui/lab/TimelineContent";

import "css/admin/comments.scss";

function LineThread({ icon, insertedAt, t }) {
  const { lang } = useSelector((state) => state.variableReducer);

  return (
    <div className="editor-line-thread-container">
      <Timeline>
        <TimelineItem>
          <TimelineSeparator>
            <TimelineConnector />
            <TimelineDot>
              <i className="material-icons">{icon}</i>
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent className="p-4">
            <b>{t("reporting")}</b>
            <span>{`${moment(insertedAt).locale(lang).format("L")} - ${moment(
              insertedAt,
            )
              .locale(lang)
              .format("LT")}`}</span>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </div>
  );
}

LineThread.propTypes = {
  icon: PropTypes.string.isRequired,
  insertedAt: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default withTranslation("editor-comments")(LineThread);
